module.exports = __webpack_public_path__ + "static/caterina-apostol-aeadf469dd8ecc51ef1ba527ae5af513.jpg";